import {ApiRequestType, onRequestFailure, onRequestSuccess} from "../middlewares/apiMiddleware";

const SLICE = 'status';

export interface StatusAPICreateDataType {
  // no args...
}

export interface StatusAPIDeleteDataType {
  // no args...
}

export interface StatusAPIUpdateDataType {
  // no args...
}

export interface StatusAPIListDataType {
  // no args...
}

export interface StatusAPIItemDataType {
  // no args...
}

export const StatusAPI = {

  create: function (data: StatusAPICreateDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream/status`,
      method: 'POST',
      data: data,
      slice: SLICE,
      action: 'create',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  delete: function (ids: StatusAPIDeleteDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream/status`,
      method: 'DELETE',
      data: {ids},
      slice: SLICE,
      action: 'delete',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  update: function (data: StatusAPIUpdateDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream/status`,
      method: 'PUT',
      data: data,
      slice: SLICE,
      action: 'update',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  list: function (data: StatusAPIListDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream/statuses`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'list',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },

  item: function (data: StatusAPIItemDataType, onRequestSuccess?: onRequestSuccess, onRequestFailure?: onRequestFailure): ApiRequestType {
    return {
      type: 'API',
      url: `/stream/status`,
      method: 'GET',
      data: data,
      slice: SLICE,
      action: 'item',
      onRequestSuccess: onRequestSuccess,
      onRequestFailure: onRequestFailure,
    };
  },
}